var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Cache } from 'app/stores/image/actions/utils';
import { getPageAt, getPagesCount } from 'app/stores/selectors';
export const persistImage = createAsyncThunk('image/persist', (source, { getState }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!configGet('imageCacheEnabled', false)) {
        return;
    }
    const state = getState();
    if (getPagesCount(state) !== 1) {
        return;
    }
    const page = getPageAt(state, 0);
    if (!page || !page.image) {
        return;
    }
    if (caches) {
        const cache = yield caches.open(Cache.vault);
        yield cache.put(Cache.imageKey, new Response(source));
    }
}));
